import { FilterValue, Specialist } from '@mindly/ui-components';
import { ISpecialist } from 'src/redux/specialists/types';

export const getMatchingValues = (filters: Record<string, FilterValue>, specialist: ISpecialist) =>
  Object.entries(filters).reduce(
    (acc: Record<string, string[]>, [key, value]) => {
      switch (key) {
        case 'specialization':
          if (Array.isArray(value)) {
            value.forEach((item) => {
              if (specialist?.specialization?.includes(item as string)) {
                acc.matching_by_specialization.push(item as string);
              }
            });
          }
          break;
        case 'areas_of_work':
          if (Array.isArray(value) && Array.isArray(specialist.areas_of_work) && specialist.areas_of_work.length > 0) {
            value.forEach((item) => {
              if (specialist.areas_of_work.includes(item as never)) {
                acc.matching_by_areas.push(item as never);
              }
            });
          }
      }
      return acc;
    },
    { matching_by_areas: [], matching_by_specialization: [] }
  );

export const getSpecialistPosition = (id: string, specialists: Specialist[]) => {
  const index = specialists.findIndex((elem) => elem?.id === id);
  return index + 1;
};
